import type { SVGProps } from "react";
export interface KiwiIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function KiwiIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: KiwiIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.053 2.364c.4-.424 1.05-.469 1.503-.122l.088.075.462.458c2.25 2.344 3.604 5.48 3.937 8.562.354 3.28-.438 6.656-2.744 8.962s-5.681 3.098-8.962 2.744c-3.082-.333-6.218-1.687-8.562-3.938l-.458-.461-.075-.088a1.126 1.126 0 0 1 1.63-1.535l.083.08.38.384c1.957 1.878 4.616 3.037 7.244 3.321 2.811.304 5.436-.404 7.13-2.098s2.4-4.318 2.097-7.129c-.284-2.629-1.443-5.287-3.32-7.244l-.386-.38-.079-.084a1.125 1.125 0 0 1 .032-1.507"
      />
      <path
        fill={color}
        d="M12.421 1.208C14.711.59 17.09.763 18.667 2.34s1.75 3.956 1.134 6.246c-.626 2.323-2.11 4.808-4.258 6.957s-4.633 3.632-6.957 4.258c-2.29.616-4.669.443-6.246-1.134s-1.75-3.956-1.132-6.246c.625-2.323 2.11-4.807 4.258-6.955s4.632-3.633 6.955-4.258m4.655 2.723c-.766-.766-2.157-1.066-4.07-.551-1.878.506-4.028 1.756-5.95 3.677-1.92 1.92-3.17 4.071-3.676 5.95-.515 1.912-.215 3.303.55 4.07.767.765 2.16 1.065 4.072.55 1.878-.506 4.027-1.756 5.948-3.677 1.921-1.92 3.171-4.07 3.677-5.948.515-1.913.215-3.305-.55-4.071Zm-12.2 11.071v-.004a1.125 1.125 0 1 1 2.25 0v.004a1.125 1.125 0 0 1-2.25 0m4.699-.699v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0m1.544-6.011a1.125 1.125 0 1 1 1.59 1.59l-2.827 2.826a1.125 1.125 0 1 1-1.59-1.59zm3.183 1.283a1.125 1.125 0 0 1 0 2.25h-.005a1.125 1.125 0 1 1 0-2.25zm-8.726.728v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0m4.727-4.727.114.004a1.127 1.127 0 0 1 0 2.24l-.114.006h-.006a1.126 1.126 0 0 1 0-2.25zm4.7-.7.115.005a1.125 1.125 0 0 1 0 2.239l-.116.006h-.004a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
